<template>
  
  <Teleport to="body">
    <div :class="className" v-show="show">
      <div v-if="region === REGION.DOMESTIC">
        <DomesticLogin
          :show="show"
          :loginWays="loginWays"
          :autoDownConfig="autoDownConfig"
          :onClose="props.onClose"
          :onFinish="props.onFinish" />
      </div>
      <div v-else>
        <InternationalLogin
          :clientId="props.clientId"
          :autoDownConfig="autoDownConfig"
          :onClose="props.onClose"
          :onFinish="props.onFinish" />
      </div>
    </div>
  </Teleport>
  
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue';
import DomesticLogin from './domestic/index.vue';
import InternationalLogin from './international/index.vue';
import configManager from '../core/config/index';
import { REGION } from '../core/constants/index';
import type { LoginProps } from './types';

const props = withDefaults(defineProps<LoginProps>(), {});

const region = configManager.get('region');
const loginWays = configManager.getLoginWays().main;

const autoDownConfig = ref({ account: true, sms: true, channel: true });
const changeAutoDownByProps = (val?: boolean | { account: boolean, sms: boolean, channel: boolean }) => {
  if (val === undefined) {
    // 如果值为undefined，则使用默认配置
    autoDownConfig.value = { account: true, sms: true, channel: true };
  } else if (typeof val === 'boolean') {
    if (val) {
      autoDownConfig.value = { account: true, sms: true, channel: true };
    } else {
      autoDownConfig.value = { account: false, sms: false, channel: false };
    }
  } else if (typeof val === 'object') {
    autoDownConfig.value = val;
  }
}
changeAutoDownByProps(props.autoDownConfig);

watch(() => props.autoDownConfig, (newVal) => {
  changeAutoDownByProps(newVal);
});

</script>
<style lang="less">
@import url('./style/index.less');
</style>